<template>
  <div>
    <div v-if="showCategory" class="menu-section iw-layout-grid">
      <div class="iw-layout-grid__row">
        <div class="menu-section__title iw-layout-grid__col--span-12-desktop iw-layout-grid__col--span-4-phone">
          <h2 :id="cleanText(categoryName).toLowerCase()">
            {{ categoryName }}
          </h2>
        </div>
      </div>
      <ul v-if="categoryItems.length" class="menu-section__content iw-layout-grid__row">
        <vendor-menu-item v-for="(item, index) in filteredCategoryItems" :key="`${item.id}-${index}`" :menu-item="item">
        </vendor-menu-item>
      </ul>
      <template v-for="(subCategory, index) in filteredSubCategories" :key="index">
        <template v-if="subCategory.items.length">
          <h3
            :id="`${cleanText(categoryName)}--${cleanText(subCategory.displayName)}`.replace(/ /g, '_').toLowerCase()"
            class="menu-section__subtitle"
          >
            {{ subCategory.displayName }}
          </h3>
          <ul class="menu-section__content iw-layout-grid__row">
            <vendor-menu-item v-for="(item, index) in subCategory.items" :key="`${index}-${item.id}`" :menu-item="item">
            </vendor-menu-item>
          </ul>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VendorMenuItem from "../menu-item/VendorMenuItem";
import { removeSpecialCharaters } from "@/utils";

export default {
  name: "VendorMenuCategory",
  components: { VendorMenuItem },
  props: {
    categoryName: String,
    categoryItems: Array,
    subCategories: Array
  },
  computed: {
    ...mapGetters({
      getShowHideStatus: "vendor/getShowHideStatus"
    }),
    filteredCategoryItems() {
      return this.categoryItems.filter((item) => this.getShowHideStatus(item));
    },
    filteredSubCategories() {
      return this.subCategories.map((subCategory) => ({
        ...subCategory,
        items: subCategory.items.filter((item) => this.getShowHideStatus(item))
      }));
    },
    showCategory() {
      //We have items in the category then display
      if (this.filteredCategoryItems.length) return true;

      //NO items in the category also no sub categories then don't display
      if (!this.subCategories.length) return false;

      //NO items in the category but subcategories then we need to look if some subcat has items
      return this.filteredSubCategories.some((subCategory) => subCategory.items.length);
    }
  },
  methods: {
    cleanText(data) {
      return removeSpecialCharaters(data);
    }
  }
};
</script>

<style scoped lang="scss">
ul {
  list-style-type: none;
}

.menu-section {
  &__title {
    padding-top: 8px;
    padding-left: $spacer;
    @include respond-to-mobile {
      padding-top: 13px;
      padding-bottom: 5px;
    }
  }

  &__subtitle {
    padding: ($spacer * 0.75) ($spacer * 0.75) ($spacer * 0.75) 28px;
    opacity: 0.7;
    font-family: Lato;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    @include respond-to-mobile {
      font-size: 16px;
      font-weight: bold;
      padding: 0 ($spacer * 0.75) ($spacer * 0.75) 24px;
    }
  }
}
</style>
